import GroupLicenseOrderConfirmationCard from "@pathwright/web/src/modules/order/GroupLicenseOrderConfirmationCard"
import RegistrationOrderConfirmationCard from "@pathwright/web/src/modules/order/RegistrationOrderConfirmationCard"
import {
  getGroupUrl,
  getStoreResourceUrl
} from "@pathwright/web/src/modules/utils/urls"
import { createCardRoutes } from "lib/core/routing/card-routing"
import LibraryResourceContainer from "library/show/components/LibraryResourceContainer"
import { loadResource } from "path/middleware"
import FinishRegistrationCard from "../order/FinishRegistrationCard"
import { useOnRegistrationOrderFulilled } from "./register/components/OrderRegistrationButton"

export const registrationRoute = createCardRoutes(
  `/library/:resourceSlug/register/:cohortId(\\d+)/`,
  {
    success: {
      path: "order/:orderId(\\d+)/thank-you/",
      middleware: loadResource,
      getDefaultLaunchedFrom: ({ match }) =>
        getGroupUrl(match.params.resourceSlug, match.params.cohortId, "about"),
      component: ({ card, match }) => {
        const onRegistrationOrderFulfilled = useOnRegistrationOrderFulilled()

        return (
          <RegistrationOrderConfirmationCard
            card={card}
            orderId={parseInt(match.params.orderId)}
            cohortId={parseInt(match.params.cohortId)}
            onOrderFulfilled={onRegistrationOrderFulfilled}
          />
        )
      }
    }
  },
  LibraryResourceContainer
)

export const groupLicenseRoute = createCardRoutes(
  `/library/:resourceSlug/resource/`,
  {
    success: {
      path: "license/:resourceLicenseId(\\d+)/order/:orderId(\\d+)/thank-you/",
      middleware: loadResource,
      getDefaultLaunchedFrom: ({ match }) =>
        getStoreResourceUrl(match.params.resourceSlug),
      component: ({ card, match }) => (
        <GroupLicenseOrderConfirmationCard
          card={card}
          orderId={parseInt(match.params.orderId)}
          licenseId={parseInt(match.params.resourceLicenseId)}
        />
      )
    }
  },
  LibraryResourceContainer
)

export const autoRegisterRoute = createCardRoutes(
  "/library/:resourceSlug/:cohortId(\\d+)/",
  {
    register: {
      path: "finish-registration",
      middleware: loadResource,
      getDefaultLaunchedFrom: () => "/library/",
      component: ({ card }) => {
        return <FinishRegistrationCard card={card} />
      }
    }
  },
  LibraryResourceContainer
)
